import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { buildHttpParams } from '../../../../core/utils/http-util';
import { endpoints } from '../../../core/constants/endpoints';
import { IConcorrente } from '../interfaces/concorrente.interface';
import { IConcorrenteFilter } from '../interfaces/concorrente-filter.interface';
import { IConcorrenteListItem, IConcorrenteListResponse } from '../interfaces/concorrente-list.interface';
import { IConcorrentePayload, ISituacaoConcorrentePayload } from '../interfaces/concorrente-payload.interface';
import { IConcorrenteSearchResponse } from '../interfaces/concorrente-search.interface';
import { IConcorrenteVinculos } from '../interfaces/concorrente-vinculos.interface';
import { IDimensaoCaracteristicas } from '../interfaces/dimensao-caracteristicas.interface';

@Injectable({ providedIn: 'root' })
export class ConcorrenteApi {
  private apiUrl = `${environment.pathApi}/${endpoints.environment.concorrentes}`;

  constructor(private http: HttpClient) {}

  search(filter: IConcorrenteFilter): Observable<IConcorrenteSearchResponse> {
    return this.http.get<IConcorrenteSearchResponse>(this.apiUrl, {
      params: buildHttpParams(filter),
    });
  }

  list(): Observable<IConcorrenteListItem[]> {
    return this.http
      .get<IConcorrenteListResponse>(`${this.apiUrl}/0/list`)
      .pipe(map((response) => response?.data ?? []));
  }

  fetchById(id: number): Observable<IConcorrente> {
    return this.http.get<IConcorrente>(`${this.apiUrl}/${id}`);
  }

  caracteristicas(): Observable<IDimensaoCaracteristicas[]> {
    return this.http.get<IDimensaoCaracteristicas[]>(`${this.apiUrl}/0/caracteristicas`);
  }

  vinculos(id: number): Observable<IConcorrenteVinculos> {
    return this.http.get<IConcorrenteVinculos>(`${this.apiUrl}/${id}/vinculos`);
  }

  create(payload: IConcorrentePayload): Observable<IConcorrente> {
    return this.http.post<IConcorrente>(this.apiUrl, payload);
  }

  update(id: number, payload: IConcorrentePayload): Observable<IConcorrente> {
    return this.http.put<IConcorrente>(`${this.apiUrl}/${id}`, payload);
  }

  updateSituacao(id: number, body: ISituacaoConcorrentePayload): Observable<IConcorrente> {
    return this.http.put<IConcorrente>(`${this.apiUrl}/${id}/situacao`, body);
  }

  delete(id: number): Observable<string> {
    return this.http.delete(`${this.apiUrl}/${id}`, { responseType: 'text' });
  }
}
